import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useController, useFormContext } from "react-hook-form";
import Button from "../../../../components/Buttons/Button";
import {
  BUTTON_ADD_RE_TARGETING,
  MODAL_CUSTOM_AUDIENCES_TITLE,
  MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE,
  RETENTION_DAYS_PLACEHOLDER,
  SIZE_PLACEHOLDER,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import AddIcon from "@mui/icons-material/Add";
import { LINKEDIN } from "../../../../utils/constants";
import ModalCustomAudiencesLinkedin from "./ModalCustomAudiencesLinkedin";
import AudienceCard from "../../../Form/AudienceCard";
import { numberCompactFormat } from "../../../../utils/numbers";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";

const platform = LINKEDIN;

const CustomAudiencesContainerLinkedin = ({
  control,
  name,
  disabled = false,
  isExcludedAudiences = false,
}) => {
  const [modalOpenCustomAudiences, setModalOpenCustomAudiences] =
    useState(false);
  const { t } = useTranslationApp();
  const { getValues } = useFormContext();

  const {
    field: { value, onChange },
  } = useController({
    name,
    control,
  });

  const customAudiences = value || [];
  const platformData = getValues(`platformsData.${platform}`) || {};

  return (
    <>
      <Grid item xs={12} id={name}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Typography
            variant="body1"
            sx={{
              mb: 2,
              display: "flex",
              alignItems: "center",
              gap: 1,
              color: "#00000",
              "& .MuiSvgIcon-root": {
                fontSize: "1.25rem",
                display: "flex",
                alignItems: "center",
                color: isExcludedAudiences
                  ? "#FF4444 !important"
                  : "#4CAF50 !important",
              },
            }}
          >
            <PersonOutlineIcon />
            {t(
              isExcludedAudiences
                ? MODAL_EXCLUDED_CUSTOM_AUDIENCES_TITLE
                : MODAL_CUSTOM_AUDIENCES_TITLE
            )}
          </Typography>
        </Box>
        <Grid container spacing={2}>
          {customAudiences.map((customAudience) => (
            <AudienceCard
              key={customAudience.id}
              title={customAudience.name}
              isValid={customAudience.isValid}
              disabled={disabled}
              onDelete={() =>
                onChange(value.filter((c) => c.id !== customAudience.id))
              }
              sx={{ color: "white" }}
            >
              {customAudience.description && (
                <Typography variant="body2">
                  {customAudience.description}
                </Typography>
              )}
              {customAudience?.retentionDays && (
                <Typography variant="body2">
                  {`${t(RETENTION_DAYS_PLACEHOLDER)}: ${customAudience.retentionDays}`}
                </Typography>
              )}
              {customAudience?.approximateCount && (
                <Typography variant="body2">
                  {`${t(SIZE_PLACEHOLDER)}: ${numberCompactFormat(customAudience?.approximateCount?.max || 0)}`}
                </Typography>
              )}
            </AudienceCard>
          ))}

          {!disabled && (
            <Grid item xs={12}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                }}
              >
                <Button
                  type="button"
                  color="secondary"
                  startIcon={<AddIcon sx={{ color: "#000 !important" }} />}
                  onClick={() => setModalOpenCustomAudiences(true)}
                  sx={{
                    p: 1,
                    width: "100%",
                  }}
                >
                  {t(BUTTON_ADD_RE_TARGETING)}
                </Button>
              </Box>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Box
        sx={{
          mb: 1,
        }}
      >
        {modalOpenCustomAudiences && (
          <ModalCustomAudiencesLinkedin
            modalOpen={modalOpenCustomAudiences}
            onCloseModal={() => setModalOpenCustomAudiences(false)}
            isExcludedAudiences={isExcludedAudiences}
            adAccountID={platformData.adAccountID}
            integrationID={platformData.integrationID}
            filteredCustomAudiences={customAudiences.map((c) => c.id)}
            onCallbackSave={(customAudiences) => {
              onChange(
                value ? [...value, ...customAudiences] : customAudiences
              );
              setModalOpenCustomAudiences(false);
            }}
          />
        )}
      </Box>
    </>
  );
};

export default CustomAudiencesContainerLinkedin;
